/**
 * Hook to check if the component has been hydrated on the client
 * Useful for avoiding hydration mismatches with Zustand persisted stores
 */

import { useState, useEffect } from "react";

export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
}
